var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoToolsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 165,
    viewBox: "0 0 143 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.27,
    y: 29.6739,
    width: 105.061,
    height: 141.541,
    transform: "rotate(90 142.27 29.6739)",
    stroke: "black",
    strokeWidth: 1.45918
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.541 30.4033L1.45938 134.005",
    stroke: "black",
    strokeWidth: 1.45918
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.322 134.305L1.68354 30.1064",
    stroke: "black",
    strokeWidth: 1.45918
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoToolsLogo);
export default __webpack_public_path__ + "static/media/no-tools-logo.1f58e3ed075c25d9676372769f5a152b.svg";
export { ForwardRef as ReactComponent };